import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const RouteRedirect = ({ to }) => {
  const history = useHistory();

  useEffect(() => {
    if (history.location.pathname !== to) {
      history.push(to);
    }
  }, []);

  return null;
};

export default RouteRedirect;
